import Vue from "vue";
import VueRouter from "vue-router";
import { TokenService } from "../api/localStorage";
import { routes } from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // Routes qui ne nécessitent pas d'authentification
  const publicRoutes = ['/',]; // publics routes
  
  if (to.meta.auth) {
    // Route protégée - vérifier l'authentification
    const hasToken = localStorage.getItem("TOKEN_KEY") !== null;
    //const loggedIn = TokenService.isUserLogined();

    if (!hasToken /*|| !loggedIn*/) {
      console.log('Utilisateur non connecté, redirection vers /');
      next({ path: "/", replace: true });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
